import Controller from '@ember/controller'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import { tracked } from '@glimmer/tracking'
import { ModalTab as BookModalTab } from 'teacher-ui-client/components/book-library/book-modal'
import type SessionService from 'teacher-ui-client/services/session'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import { SchoolClassOptionTypes } from 'teacher-ui-client/components/base/select/school-class/options'

/**
 * top-level book library controller, actions the loading/display of a book
 * modal that can be triggered across various descendent routes.
 */
export default class BookLibraryController extends Controller {
  @service router!: RouterService

  @service subscriptionType!: SubscriptionTypeService

  @service session!: SessionService

  queryParams = ['bookTab', 'bookId']

  @tracked bookId?: string

  @tracked bookTab: BookModalTab = BookModalTab.bookDetails

  get isSubco() {
    return this.subscriptionType.current && this.session.currentTeacher.subcoFor(this.subscriptionType.current)
  }

  SchoolClassOptionTypes = SchoolClassOptionTypes

  closeBookModal = () => {
    void this.router.transitionTo({
      queryParams: { bookId: undefined, bookTab: BookModalTab.bookDetails },
    })
  }
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/book-library': BookLibraryController
  }
}
